import { Authenticationservice } from './../../services/authentication.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import axios from 'axios';
import { async } from '@rxweb/reactive-form-validators';
declare var $: any;
@Component({
  selector: 'app-editcaneinplant',
  templateUrl: './editcaneinplant.component.html',
  styleUrls: ['./editcaneinplant.component.css']
})
export class EditcaneinplantComponent implements OnInit {
  userdata:any;
  constructor(private auth:Authenticationservice,private spinner: NgxSpinnerService) {
    this.userdata = this.auth.Authention();
   }

  ngOnInit(): void {
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  onedata:any;
  chosedata(id:any) {
    this.onedata = this.queuedata.filter(el=> el.truck_q === id);
    $("#exampleModal").modal('show');
  }

  closemodal() {
    $("#exampleModal").modal('hide');
  }

  // โหลดข้อมูลแปลง
  plantdata:any;
  fmcode:any;
  async Findplantdata(){
    this.spinner.show();
    axios.get('https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_v_cp_data_w?year=2122&FMCODE='+this.fmcode).then(res => {
     this.plantdata =  res.data.recordset;
     
      this.spinner.hide();
      }).catch(err => { this.spinner.hide();
      throw(err)
    });
       this.spinner.hide();
  }

  // โหลดข้อมูลคิว
  queuedata:any;
  tabledata:any;
  @ViewChild('table', {static:false}) fmTable:any;
  async Findqueuetdata(){
    this.spinner.show();
    if (this.tabledata != undefined)
    { 
      this.tabledata.destroy();  
    }
    else {}
    axios.get('https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_v_qcard_wgt_w?FMCODE_b1='+this.fmcode).then(res => {
     this.queuedata =  res.data.recordset;
     setTimeout(() => {
      this.tabledata = $(this.fmTable.nativeElement).DataTable();
      }, 1500);
      this.spinner.hide();
      }).catch(err => { this.spinner.hide();
      throw(err)
    });
    await this.Findplantdata();
       this.spinner.hide();
  }

  // อัพเดทข้อมูล
  changeitid:any;
  updateData(){
    console.log(this.changeitid);
    if(this.changeitid == null || this.changeitid == undefined){
      alert('กรุณาเลือกแปลงก่อนบันทึก');
      return false;
    }
    else {
      let url ="https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_qcard_w?truck_q="+this.onedata[0].truck_q+"&itid="+this.changeitid[1]+"&landno="+this.changeitid[1];
    axios.post(url).then(res => {
     if (res.data.rowsAffected[0]==1)
       {alert('อัพเดทข้อมูลแล้ว'); 
       this.Findqueuetdata }
     else{alert('อัพเดทล้มเหลวลองใหม่อีกครั้ง'); }
       }).catch(err => { this.spinner.hide();
       throw(err)
     });
    this.closemodal();
    }
    
  }

}
